import { defineComponent, toRefs } from 'vue'
import BodyCell from './bodyCell'
export default defineComponent({
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    collapseColumns: {
      type: Array,
      default: () => ([])
    }
  },
  setup (props) {
    const { columns, data } = toRefs(props)
    const generateDataItems = (cols) => {
      const items = []
      // console.log('body')
      cols.forEach((col, i) => {
        if (col.children && col.children.length) {
          items.push(...generateDataItems(col.children))
        } else {
          data.value.forEach((item, dataIndex) => {
            (!col.rowSpan || col.rowSpan(item)) && items.push(
              <BodyCell col={col} item={item} collapseColumns={ props.collapseColumns }></BodyCell>
            )
          })
        }
      })
      return items
    }
    return () => generateDataItems(columns.value)
  }
})
